import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import styles from "../../styles/common/sideCard.module.css";
import ProfileIcon from "../common/profileIcon";
import { Link as RouterLink } from "react-router-dom";

type authorInfoProps = {
  user_name: string;
  experience: string;
  user_id: number;
};

const TeamInfoCard = (props: authorInfoProps) => {
  return (
    <Card className={styles.card} elevation={4} sx={{ borderRadius: "10px" }}>
      <Typography gutterBottom variant="h6" component="div">
        Author Information
      </Typography>
      <CardContent className={styles.cardContent}>
        <CardActionArea
          component={RouterLink}
          to={"/proposer/" + props.user_id}
        >
          <div className={styles.pullLeft}>
            <ProfileIcon
              userName={props.user_name ? props.user_name.trim() : "Anonymous"}
            />
            <Typography gutterBottom variant="body1" component="div">
              {props.user_name}
            </Typography>
          </div>
        </CardActionArea>
        <Typography variant="body2">{props.experience}</Typography>
      </CardContent>
    </Card>
  );
};

export default TeamInfoCard;
